<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        size="lg"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > iCare Youth Name </label>
             <CRow >
              <CCol >
               <b-input v-model="form.name" placeholder='iCare Name' :class="errors.name ? 'is-invalid' : '' " class="mb-1"> </b-input>
              <b-form-invalid-feedback>
              Your icare name must be filled
              </b-form-invalid-feedback>
              </CCol>
            </CRow>       
            <label class="mt-2"> City </label>
             <CRow >
              <CCol >
              <b-input v-model="form.city" placeholder='City' :class="errors.city ? 'is-invalid' : ''" class="mb-1"> </b-input>
              <b-form-invalid-feedback >
              Your city name must be filled
              </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <label > State </label>
             <CRow >
              <CCol >
              <b-input v-model="form.state" placeholder='State' :class="errors.state ? 'is-invalid' : ''" class="mb-1"> </b-input>
              <b-form-invalid-feedback >
              Your zone name must be filled
              </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <label > Country </label>
             <CRow >
              <CCol >
              <b-input v-model="form.country" placeholder='Country' :class="errors.country ? 'is-invalid' : ''" class="mb-1"> </b-input>
              <b-form-invalid-feedback>
              Your country name must be filled
              </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <label > Zone </label>
             <CRow class="mt-0"    >
              <CCol >
               <b-form-select
                v-model="form.zone_id"
                :options= "options"
            >
              </b-form-select>
              </CCol>   
            </CRow>
            
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Edit</CButton>
     
        </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import icare from '@/services/icareyouth';
import zone from '@/services/zone';

import moment from 'moment';

export default {
name: 'icaremodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    errors: {},
    errors_from_backend: [],
    form:{
      uuid:'',
      name:'',
      city:'',
      state:'',
      country:'',
      zone_id:'',
      leader_id:'',
      moment:'',
    },
    options:[],
    loading: false,
    }
  },
  computed: {
     
   },
  
  mounted(){
    
  },
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_ICARE', (params) => {
      if(params.data){
      icare.getIcarebyID(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = res.data.id;
      self.form.name = res.data.name;
      self.form.city = res.data.city;
      self.form.state = res.data.state;
      self.form.country = res.data.country;
      self.form.zone_id = res.data.zone_id;
      self.form.leader_id = res.data.leader_id;
       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.name = "";
        self.form.city = "";
        self.form.state = "";
        self.form.country = "";
        self.form.zone_id = "";
        self.form.leader_id = "";
      }
 
    });
    zone.getZone()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options.push({text: res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
        
      })
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.loading = true;
      if (this.check_form()) {
      icare.createIcare(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
          this.show = false;
      }).catch((err) => {
      this.loading = false;
      alert(err.response.data.message);
      //alert(JSON.stringify(err.response.data.errors));
      if (err.response.data.errors != null) {
          this.errors_from_backend = err.response.data.errors;
          console.log(JSON.stringify(err.response.data.errors));
      }
    });
    } else {
      this.loading = false;
    }
  },
  
    update(id){
      this.show = false;
      icare.updateIcare(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    check_form: function(e) {
         this.errors = {};
         if (!this.form.name) {
            this.errors["name"] = "1";
         }
         if (!this.form.city) {
            this.errors["city"] = "1";
         }
         if (!this.form.state) {
            this.errors["state"] = "1";
         }
         if (!this.form.country) {
            this.errors["country"] = "1";
         }
         if (
            this.form.name &&
            this.form.city &&
            this.form.state &&
            this.form.country 
         ) {
            return true;
         } else {
            return false;
         }
      },
   
  }
}
</script>

<style>

</style>